export default __webpack_public_path__ + "static/media/lux_adria-logo.bf27a5d9.svg";